export interface DriverActionTypes {
  type: DriverActions;
  payload?: any;
}

export enum DriverActions {
  CREATE_DRIVER = "CREATE_DRIVER",
  GET_DRIVER_LIST = "GET_DRIVER_LIST",
  SET_DRIVER_LIST = "SET_DRIVER_LIST",
  SET_DRIVER_LIST_PAGE_COUNT = "SET_DRIVER_LIST_PAGE_COUNT",
  GET_DRIVER_DATA_BY_ID = "GET_DRIVER_DATA_BY_ID",
  SET_DRIVER_DATA_BY_ID = "SET_DRIVER_DATA_BY_ID",
  EDIT_DRIVER_DATA_BY_ID = "EDIT_DRIVER_DATA_BY_ID",
}
